import {ScreenBackGround} from './screen-background.styled'
import {type ReactNode, type JSX} from 'react'

interface LoginPageTemplateProps {
    children: ReactNode
}

export function LoginPageTemplate({children}: LoginPageTemplateProps): JSX.Element {
    return <ScreenBackGround>{children}</ScreenBackGround>
}
